import './App.css';
import SocialFollow from "./components/SocialFollow";
import { useState } from "react";
import DalleImg from "./images/dalle.gif";
import { Container, Row, Col } from 'react-bootstrap';
import { Configuration, OpenAIApi } from "openai";

const configuration = new Configuration({
  apiKey: process.env.REACT_APP_API_KEY,
});

const openai = new OpenAIApi(configuration);

function App() {
  const [userPrompt, setUserPrompt] = useState(""); // Valor del prompt
  const [imageUrl, setImageUrl] = useState("");
  const [loadingImage, setLoadingImage] = useState(false);
  const [error, setError] = useState(""); // Estado para manejar errores

  const onInput = (e) => setUserPrompt(e.target.value); // Actualiza userPrompt

  const onClear = () => {
    setUserPrompt(""); // Limpiar el campo de entrada
  };

  const generateImage = async () => {
    if (!userPrompt.trim()) {
      setError("Please fill out the input field."); // Mensaje de error si el input está vacío
      return; // No hacer nada si el prompt está vacío
    }
    
    setLoadingImage(true);
    setError(""); // Limpiar errores antes de una nueva solicitud
    
    try {
      const imageParameters = {
        prompt: userPrompt,
        n: 1,
        size: "512x512",
      };
      const response = await openai.createImage(imageParameters);
      const urlData = response.data.data[0].url;
      console.log(urlData);
      setImageUrl(urlData);
    } catch (error) {
      console.error("Error details:", error); // Ver detalles del error en la consola
      if (error.response) {
        // Revisa si error.response y error.response.data están definidos
        console.error("Error response:", error.response.data);
        if (error.response.data.error && error.response.data.error.code === "billing_hard_limit_reached") {
          setError("The billing limit has been reached.");
        } else {
          setError("Error generating the image. Please try again.");
        }
      } else {
        setError("Error in the request. Please try again.");
      }
    } finally {
      setLoadingImage(false);
    }
  };

  return (
    <Container className='mt-5'>
      <Row className='text-center'>
        <Col className='title col-md-12 col-sm-12 col-xl-6'>
          <blockquote>
            <p>Generate a unique image using DALL·E</p>
            <p>What do you want to see?</p>
          </blockquote>

          <div className="input-group">
            <input
              className="input"
              onInput={onInput}
              value={userPrompt} // Usar userPrompt para el valor del input
              onChange={(e) => setUserPrompt(e.target.value)}
              onClick={onClear}
            />
            <button
              type="submit"
              className="button--submit"
              onClick={generateImage}
            >
              {loadingImage ? 'Loading...' : 'Generate'}
            </button>
          </div>

          {error && <p className="error-message">{error}</p>} {/* Mostrar mensaje de error */}
        </Col>

        <Col className='mt-5 col-md-12 col-sm-12 col-xl-6'>
          {imageUrl ? (
            <img src={imageUrl} className="image" alt="generated img" />
          ) : (
            <img src={DalleImg} className="image" alt="DALL-E" />
          )}
        </Col>
      </Row>

      <SocialFollow />
    </Container>
  );
}

export default App;
